import { useQuery } from '@tanstack/react-query';
import { getProcessedTimesheetAttachments } from '../Services/ProcessedTimesheetService';

const useGetProcessedTimesheetAttachments = (params, options) =>
    useQuery(
        ['processedTimesheetAttachments', params],
        () => getProcessedTimesheetAttachments(params),
        options
    );

export default useGetProcessedTimesheetAttachments;
